export const checklistDocument = {
    addTitleForm: "Een pdf-checklist toevoegen",
    updateTitleForm: "Een PDF-checklist vervangen",
    uploadNewDoc: "Uploaden",
    modifyDoc: "Vervangen"
}